/* eslint-disable max-len */
import { SvgIcon, colors } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import { noop } from 'lodash';
import * as React from 'react';

const Email: React.FC<CustomSvgIcon> = ({
    id = '',
    className = '',
    iconColor = `${colors.common.black}`,
    onClick = noop
}) => {
    return (
        <SvgIcon
            className={className}
            id={id}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 14 10'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>Email</title>
                <g>
                    <path
                        d='M12.7485 0H1.25173C0.561406 0 0 0.538348 0 1.20032V8.5999C0 9.26165 0.561406 9.80022 1.25173 9.80022H12.7485C13.4386 9.80022 14.0002 9.26187 14.0002 8.5999V1.20032C14.0002 0.538568 13.4388 0 12.7485 0ZM9.05512 4.97823L13.4425 1.59786V8.07125L9.05512 4.97823ZM1.25173 0.534822H12.7485C13.0392 0.534822 13.2885 0.707146 13.3917 0.950868L7.3254 5.62478C7.11881 5.7841 6.88165 5.7841 6.67506 5.62478L0.608516 0.950868C0.711697 0.707146 0.961032 0.534822 1.25173 0.534822ZM0.55773 1.59786L4.94511 4.97823L0.55773 8.07125V1.59786ZM12.7485 9.26518H1.25173C0.914153 9.26518 0.632185 9.0327 0.570598 8.72617L5.38633 5.33125C5.38932 5.32927 5.39185 5.32684 5.3946 5.32464L6.32553 6.04192C6.53052 6.1997 6.76514 6.27859 7 6.27859C7.23486 6.27859 7.46972 6.1997 7.67447 6.04192L8.6054 5.32464C8.60816 5.32684 8.61091 5.32905 8.61367 5.33125L13.4294 8.72617C13.3676 9.03292 13.0858 9.26518 12.7483 9.26518H12.7485Z'
                        fill={iconColor}
                    />
                </g>
            </svg>
        </SvgIcon>
    );
};

export default Email;